module.exports = __webpack_public_path__ + "img/member-second-circle.186743a4.svg";